import React from 'react';
import { motion } from 'framer-motion';
const moments = [{
  title: 'Slow mornings.',
  body: 'Coffee, journaling, ocean air. The kind of slow you forgot was possible.',
  img: 'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=900&q=80&auto=format&fit=crop'
}, {
  title: 'Days to wander.',
  body: 'Surf. Markets. Hidden spots. Try something new — or do nothing at all.',
  img: 'https://images.unsplash.com/photo-1502680390469-be75c86b636f?w=900&q=80&auto=format&fit=crop'
}, {
  title: 'Long, lit dinners.',
  body: "Locals come through. Travelers join. Conversations you'll text about later.",
  img: 'https://images.unsplash.com/photo-1529543544282-ea669407fca3?w=900&q=80&auto=format&fit=crop'
}, {
  title: 'A new pulse.',
  body: 'Leave with more connection — to others, to the place, to yourself.',
  img: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?w=900&q=80&auto=format&fit=crop'
}];
export function AWeekWithUs() {
  return <section id="week" className="bg-paper py-24 md:py-36 px-6 md:px-10" data-id="element-28">
      <div className="max-w-6xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9
      }} className="mb-16 md:mb-24 max-w-2xl" data-id="element-30">
          <p className="eyebrow mb-5" data-id="element-31">A week with us</p>
          <h2 className="font-serif-display text-3xl md:text-5xl text-ink leading-[1.1]" data-id="element-32">
            Four beats. <span className="italic" data-id="element-33">One quiet shift.</span>
          </h2>
        </motion.div>

        <div className="space-y-20 md:space-y-28" data-id="element-34">
          {moments.map((m, i) => {
          const reverse = i % 2 === 1;
          return <motion.div key={m.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.9
          }} className={`grid grid-cols-12 gap-6 md:gap-12 items-center ${reverse ? 'md:[&>*:first-child]:order-2' : ''}`} data-id="element-35">
                <div className="col-span-12 md:col-span-7 aspect-[4/3] overflow-hidden" data-id="element-36">
                  <img src={m.img} alt={m.title} className="w-full h-full object-cover" data-id="element-37" />
                </div>
                <div className="col-span-12 md:col-span-5 md:px-2" data-id="element-38">
                  <p className="font-serif-display text-6xl md:text-7xl text-ink/15 italic leading-none" data-id="element-39">
                    {String(i + 1).padStart(2, '0')}
                  </p>
                  <h3 className="mt-4 font-serif-display text-2xl md:text-4xl text-ink leading-snug" data-id="element-40">
                    <span className="italic" data-id="element-41">{m.title}</span>
                  </h3>
                  <p className="mt-4 text-ink-soft text-[15px] leading-[1.8] max-w-md" data-id="element-42">
                    {m.body}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}